export const formatDateToString = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export const convertStringToDate = (date: string) => {
    const newDate = new Date(date);
    return newDate;
}

export const transformDateToDots = (date: string) => {
    const [day, month, year] = date.split('-');
    return `${day}.${month}.${year}`;
}